import { Component, forwardRef, Input, OnDestroy, OnInit } from "@angular/core";
import {
  ControlValueAccessor,
  FormBuilder,
  FormControl,
  FormGroup,
  NG_VALUE_ACCESSOR,
} from "@angular/forms";
import { Subject } from "rxjs";
import { pairwise, takeUntil } from "rxjs/operators";
import { InsideSurvey } from "src/app/shared/Models/read";
import { FormValidationService } from "src/app/core/survey/shared/services/formValidation.service";
import {
  InsideSurveyInsideInfo,
  INSIDE_SURVEY_INSIDE_TECHNICAL_INFO,
} from "../../../../config/inside-survey.magic-strings";
import { TSAType } from "../../../../models/tsaType.enum";
import { SurveyStatus } from "src/app/shared/Models/enums/SurveySurveyStatus";

@Component({
  selector: "app-no-admin-tsa",
  templateUrl: "./no-admin-TSA.component.html",
  styleUrls: ["./no-admin-TSA.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NoAdminTSAComponent),
      multi: true,
    },
    FormBuilder,
  ],
})
export class NoAdminTSAComponent
  implements OnInit, ControlValueAccessor, OnDestroy
{
  @Input() isAuthCanWrite: boolean;
  @Input() survey: InsideSurvey;

  insideSurveyInsideInfo = InsideSurveyInsideInfo;
  surveyStatus = SurveyStatus;
  noAdminTSAForm: FormGroup = new FormGroup({});
  formChanges: Subject<Partial<InsideSurvey>> = new Subject<
    Partial<InsideSurvey>
  >();
  types = TSAType;

  constructor(
    private formValidationService: FormValidationService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.buildForm();
  }

  destroy$ = new Subject();
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  writeValue(obj: any): void {
    this.noAdminTSAForm.patchValue({
      ...obj,
    });
  }

  registerOnChange(fn: any): void {
    this.formChanges.pipe(takeUntil(this.destroy$)).subscribe(fn);
  }

  registerOnTouched(fn: any): void {
    this.onTouched();
  }

  onTouched = () => null;

  setDisabledState?(isDisabled: boolean): void {
    throw new Error("Method not implemented.");
  }

  private buildForm() {
    this.noAdminTSAForm = this.fb.group({
      tsaType: [{ value: "", disabled: this.arecheckboxesReadOnly }, []],
    });

    this.noAdminTSAForm.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((val) => this.formChanges.next(val));
  }

  get arecheckboxesReadOnly() {
    return (
      this.isAuthCanWrite === false ||
      this.survey.surveyStatus == SurveyStatus.InsideDone
    );
  }

  getErrors(subTitle?: string, field?: string) {
    return this.formValidationService.getErrors(
      ...[INSIDE_SURVEY_INSIDE_TECHNICAL_INFO, subTitle, field].filter(
        (x) => !!x
      )
    );
  }

  get showErrorMessage() {
    return this.survey.isDocumentStatusPending === false;
  }
}
